import React from 'react';
import Link from 'next/link';

export type LinkWrapperProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
};

function LinkWrapper(props: LinkWrapperProps): JSX.Element {
  return (
    <Link href={props.href} prefetch={false} className={props.className}>
      {props.children}
    </Link>
  );
}

export default LinkWrapper;
